import React from "react";

const ClientGrid = ({ data }) => {

  let clientGridItems = data.items;

  return (
    <React.Fragment>
      <div className="grid grid-home row">
        {data.items && data.items.map((image, i) => {
          return (
            <div key={i} className="col-md-2 col-xs-6 thumb">
              <img
                src={image.client_grid_image.url}
                alt={image.client_grid_image.alt}
                className="width-75p client-image"
              />
            </div>
          );
        })}
      </div>
    </React.Fragment>
  )

}

export default ClientGrid;